import { createSelector } from 'reselect'
import { RootState } from 'shared/stores'

export const loginStateSelector = (state: RootState) => state.rp4.login

export const userSelector = createSelector(loginStateSelector, state => state.user)
export const userIsAuthenticated = createSelector(loginStateSelector, state => typeof state.user !== "undefined")
export const loadingSelector = createSelector(loginStateSelector, state => state.loading)
export const isVisible = createSelector(loginStateSelector, state => state.isSidebarVisible)
export const flowSelector = createSelector(loginStateSelector, state => state.flow)